/**
 * Checks if value using a ("===") the comparison.
 * @param value The value being checked.
 * @param target The target value to perform the check against.
 * @return True if the value equals the target, false otherwise.
 */
export function isEqualTo(value: any, target: any): boolean {
    return value === target;
}
